export default {
  form: {
    delivery: 'delivery',
    payment_group: 1,
    payment_method: 'paymaya',
    payment_type: 'straight',
    payment_term: '',
    first_name: '',
    last_name: '',
    email: '',
    address_1: '',
    address_2: '',
    state_id: '',
    city_id: '',
    contact_number: '',
    time: '',
    date: '',
    notes: '',
    hasVoucher: false,
    saveInformation: true,
  },
  loading: false,
  errors: {},
}
